var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Exception',{attrs:{"type":"404","img-color":"","desc":_vm.$t('page.exception.e404'),"back-text":_vm.$t('page.exception.btn')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }